import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Input } from 'antd';
import classNames from 'classnames';
import s from './index.module.less';
import InputArea from './InputArea';
import { InputPropsType } from './types';

const MobileNumberInput = ({
  className,
  incrementButton,
  decrementButton,
  inputValue,
  input,
  loading,
  disabled,
}: InputPropsType) => (
  <div className={className}>
    <Input.Group compact>
      <Button
        icon={<MinusOutlined style={{ fontSize: 12 }} />}
        {...decrementButton}
        disabled={disabled}
        className={classNames(s.button, s.decrement)}
        data-test="decrease"
      />

      <InputArea
        value={inputValue}
        className={classNames(s.mobileInput)}
        loading={loading}
        input={input}
        disabled={disabled}
        dataTest="mobile-number-input"
      />

      <Button
        icon={<PlusOutlined style={{ fontSize: 12 }} />}
        {...incrementButton}
        disabled={disabled}
        className={classNames(s.button, s.increment)}
        data-test="increase"
      />
    </Input.Group>
  </div>
);

export default MobileNumberInput;
